import { notifications } from '@mantine/notifications';

import { Notification } from '@/shared/uikit/components/notification';

export const useShowNotifaction = ({
	text,
	type,
	autoClose,
	withCloseButton = true,
	widget,
}: {
	text: string;
	type: 'success' | 'warning' | 'error' | 'favourite';
	autoClose?: boolean | number;
	withCloseButton?: boolean;
	widget?: React.ReactNode;
}) => {
	switch (type) {
		case 'success':
			notifications.show({
				message: <Notification text={text} widget={widget} />,
				bg: '#40c057',
				mah: '100%',
				maw: 'fit-content',
				mx: 'auto',
				autoClose: autoClose ?? 5000,
				withCloseButton: withCloseButton,
			});
			break;
		case 'error':
			notifications.show({
				message: <Notification text={text} type="error" widget={widget} />,
				bg: '#ff0000',
				mah: '100%',
				maw: 'fit-content',
				mx: 'auto',
				radius: 12,
				autoClose: autoClose ?? 5000,
				withCloseButton: withCloseButton,
			});
			break;
		case 'favourite':
			notifications.show({
				message: <Notification text={text} action="favorite" widget={widget} />,
				bg: '#ff4405',
				mah: '100%',
				maw: 'fit-content',
				mx: 'auto',
				radius: 12,
				autoClose: autoClose ?? 5000,
				withCloseButton: withCloseButton,
			});
			break;
	}
};
